"use strict";
/**
 * @fias/analytics-types
 *
 * Shared event taxonomy for first-party platform usage analytics.
 *
 * The client tracker (client/src/lib/analytics.ts) and the server
 * ingestion validator (services/api-service/src/routes/analytics/
 * events.ts) both import from here. There is no second copy. The
 * divergence test in src/__tests__/taxonomy.test.ts is the
 * structural guard.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllowedEventName = exports.SESSION_END_REASONS = exports.ARCHE_OPENED_SOURCES = exports.EVENT_NAMES_BY_TYPE = exports.EVENT_TYPES = void 0;
var event_types_1 = require("./event-types");
Object.defineProperty(exports, "EVENT_TYPES", { enumerable: true, get: function () { return event_types_1.EVENT_TYPES; } });
Object.defineProperty(exports, "EVENT_NAMES_BY_TYPE", { enumerable: true, get: function () { return event_types_1.EVENT_NAMES_BY_TYPE; } });
Object.defineProperty(exports, "ARCHE_OPENED_SOURCES", { enumerable: true, get: function () { return event_types_1.ARCHE_OPENED_SOURCES; } });
Object.defineProperty(exports, "SESSION_END_REASONS", { enumerable: true, get: function () { return event_types_1.SESSION_END_REASONS; } });
Object.defineProperty(exports, "isAllowedEventName", { enumerable: true, get: function () { return event_types_1.isAllowedEventName; } });
//# sourceMappingURL=index.js.map